// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stock-view {
  position: relative; /* Ensure child elements are positioned relative to this container */
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  border: 1px solid white;
  padding: 1rem;
  gap: 2rem;
}
.stock-view__totals-rows {
  height: 8vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.5vh;
}
.stock-view__totals-rows__row {
  display: flex;
  flex-direction: row;
  gap: 0.5vw;
}
.stock-view__totals-rows__row__value {
  font-weight: bold;
}

.mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(193, 193, 193, 0.32);
  z-index: 100;
}

.popup {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  z-index: 101;
}`, "",{"version":3,"sources":["webpack://./src/features/profile/components/stock-view/stock-view.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA,EAAA,oEAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,aAAA;EACA,SAAA;AACJ;AACI;EACI,WAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,UAAA;AACR;AAAQ;EACI,aAAA;EACA,mBAAA;EACA,UAAA;AAEZ;AAGY;EACI,iBAAA;AADhB;;AAOA;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,2CAAA;EACA,YAAA;AAJJ;;AAOA;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,wCAAA;EACA,YAAA;AAJJ","sourcesContent":[".stock-view {\n    position: relative; /* Ensure child elements are positioned relative to this container */\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    height: 100%;\n    border: 1px solid white;\n    padding: 1rem;\n    gap: 2rem;\n\n    &__totals-rows{\n        height: 8vh;\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n        gap: 0.5vh;\n        &__row{\n            display: flex;\n            flex-direction: row;\n            gap: 0.5vw;\n            &__label{\n              \n            }\n\n            &__value{\n                font-weight: bold;\n            }\n        }\n    }\n}\n\n.mask {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(193, 193, 193, 0.32);\n    z-index: 100;\n}\n\n.popup {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background: white;\n    padding: 2rem;\n    border-radius: 8px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n    z-index: 101;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
